module.exports = __webpack_public_path__ + "static/media/5-9.f0b1ed49.webp";